import { useLocation, useNavigate, matchPath } from 'react-router-dom';
import useAppSelector from 'src/hooks/useAppSelector';
import { useDispatch } from 'react-redux';
import {
    selectActiveBranchId,
    setActiveBranch,
} from 'src/store/selected-branch';
import { baseApi } from 'src/api';

export function useBranchNavigation() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const activeBranchId = useAppSelector(selectActiveBranchId);

    const changeBranch = newBranchId => {
        if (!newBranchId) return;
        if (newBranchId === activeBranchId) return;

        dispatch(setActiveBranch({ branchId: newBranchId }));

        const isBranchRoute = matchPath(
            { path: '/b/:branchId/*' },
            location.pathname
        );

        if (isBranchRoute) {
            const currentBranchIdFromUrl = isBranchRoute.params.branchId;

            const newPath = location.pathname.replace(
                `/b/${currentBranchIdFromUrl}`,
                `/b/${newBranchId}`
            );

            navigate(newPath + location.search + location.hash);
        }

        dispatch(
            baseApi.util.invalidateTags([
                'Student',
                'Group',
                'Timetable',
                'AttendanceHistory',
                'StudentAttendance',
                'Academic',
                'Audience'
            ])
        );
    };

    return {
        activeBranchId,
        changeBranch,
    };
}
